// import React, { useEffect, useState } from 'react';
// import TripServices from '../../services/externalServices/trip/TripServices';
// import ItemTourPackage from './ItemTourPackage';

// function TripList() {
//   const [trips, setTrips] = useState([]);
//   const [filteredTrips, setFilteredTrips] = useState([]);
//   const [activeTab, setActiveTab] = useState('All');

//   useEffect(() => {
//     getTrips();
//   }, []);

//   const getTrips = async () => {
//     try {
//       const res = await TripServices.getAllTrips();
//       console.log('TripServices.getAllTrips', res.trips);
  
//       // Sort trips by created_at in descending order (latest first)
//       const sortedTrips = res.trips.sort((a, b) => new Date(b.tripDate) - new Date(a.tripDate));

//       setTrips(sortedTrips);
//       setFilteredTrips(sortedTrips);
//     } catch (error) {
//       console.error('Error getting the user trips', error);
//     }
//   };
  

//   const filterTrips = (status) => {
//     setActiveTab(status);
//     if (status === 'All') {
//       setFilteredTrips(trips);
//     } else {
//       const filtered = trips.filter((trip) => trip.status === status);
//       setFilteredTrips(filtered);
//     }
//   };

//   return (
//     <div className='w-full min-h-screen bg-gray-100 p-5'>
//       <h1 className='text-2xl font-bold text-center mb-4'>Trip List</h1>
      
//       {/* Tabs */}
//       <div className='flex justify-center space-x-4 mb-6'>
//         {['All', 'INITIATED', 'COMPLETED', 'BOOKED'].map((status) => (
//           <button
//             key={status}
//             className={`px-4 py-2 rounded-lg font-medium transition ${
//               activeTab === status ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800'
//             }`}
//             onClick={() => filterTrips(status)}
//           >
//             {status}
//           </button>
//         ))}
//       </div>

//       {/* Trip Cards */}
//       <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
//         {filteredTrips?.length > 0 ? (
//           filteredTrips?.map((trip, index) => <ItemTourPackage key={index} item={trip} />)
//         ) : (
//           <p className='text-center text-gray-500 col-span-full'>No trips found</p>
//         )}
//       </div>
//     </div>
//   );
// }

// export default TripList;

import React, { useEffect, useState } from 'react';
import TripServices from '../../services/externalServices/trip/TripServices';
import ItemTourPackage from './ItemTourPackage';

function TripList() {
  const [trips, setTrips] = useState([]);
  const [filteredTrips, setFilteredTrips] = useState([]);
  const [activeTab, setActiveTab] = useState('All');

  useEffect(() => {
    getTrips();
  }, []);

  const getTrips = async () => {
    try {
      const res = await TripServices.getAllTrips();
      console.log('TripServices.getAllTrips', res.trips);
  
      // Sort trips by created_at in descending order (latest first)
      const sortedTrips = res.trips.sort((a, b) => new Date(b.tripDate) - new Date(a.tripDate));

      setTrips(sortedTrips);
      setFilteredTrips(sortedTrips);
    } catch (error) {
      console.error('Error getting the user trips', error);
    }
  };

  const filterTrips = (status) => {
    setActiveTab(status);
    if (status === 'All') {
      setFilteredTrips(trips);
    } else {
      const filtered = trips.filter((trip) => trip.status === status);
      setFilteredTrips(filtered);
    }
  };

  return (
    <div className='w-full min-h-screen bg-gray-100 p-5 mt-16 sm:p-4 md:p-5'>
      <h1 className='text-xl sm:text-2xl font-bold text-center mb-3 sm:mb-4'>Trip List</h1>
      
      {/* Tabs - Made scrollable for small screens */}
      <div className='flex overflow-x-auto pb-2 mb-4 sm:mb-6 hide-scrollbar'>
        <div className='flex space-x-2 sm:space-x-4 mx-auto px-2'>
          {['All', 'INITIATED', 'COMPLETED', 'BOOKED'].map((status) => (
            <button
              key={status}
              className={`px-3 py-1 sm:px-4 sm:py-2 text-sm sm:text-base rounded-lg font-medium transition whitespace-nowrap ${
                activeTab === status ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-800'
              }`}
              onClick={() => filterTrips(status)}
            >
              {status}
            </button>
          ))}
        </div>
      </div>

      {/* Trip Cards - Adjusted grid for smaller screens */}
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4'>
        {filteredTrips?.length > 0 ? (
          filteredTrips?.map((trip, index) => (
            <ItemTourPackage key={index} item={trip} />
          ))
        ) : (
          <p className='text-center text-gray-500 col-span-full py-8'>
            No trips found
          </p>
        )}
      </div>

      {/* Add some CSS to hide scrollbar but keep functionality */}
      <style jsx>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
}

export default TripList;
